import { render, staticRenderFns } from "./howItWorks-v2.vue?vue&type=template&id=c65cae4a"
import script from "./howItWorks-v2.vue?vue&type=script&lang=js"
export * from "./howItWorks-v2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports